import { EventType } from "@/types/Event";

export const orderEvents = (events:EventType[])=>{
    return events.sort((a, b) => (new Date(a.date) as unknown as number) - (new Date(b.date) as unknown as number));
}